export const PRIMARY_COLOR = "#39B3FF";

export const SUCCESS_COLOR = "#00AA06";
export const SUCCESS_LIGHT_COLOR = "#06d40c";
export const SUCCESS_DARK_COLOR = "#057308";
export const WARNING_COLOR = "#F1B800";
export const ERROR_COLOR = "#FF0000";

export const ORANGE_COLOR = "#EE7E22";

export const DARK_BLUE_COLOR = "#003657";
export const GRAY_COLOR = "#555555";
export const LIGHT_GRAY_COLOR = "#777777";
export const WHITE_COLOR = "#FFFFFF";

export const TRANSPARENT_WHITE_COLOR = "#FFFFFF88";

export const SECONDARY_COLOR = "#003657";
